import { api } from "../axios";
import { User } from "@/types/auth.types";

export const workerService = {
  acceptPrivacyPolicy: async (workerId: string): Promise<User> => {
    const { data } = await api.put<{ success: boolean; data: User }>(`/workers/${workerId}`, {
      privacyAccepted: true,
    });
    return data.data;
  },

  updateWorker: async (workerId: string, payload: any): Promise<User> => {
    const { data } = await api.put<{ success: boolean; data: User }>(`/workers/${workerId}`, payload);
    return data.data;
  },
};
